import { Box, Tooltip, styled, useMediaQuery, useTheme } from '@mui/material';
import Dropdown2 from '../../common/DropDown2';
import { LanguageList } from '../../../utils/data';
import { useTranslation } from 'react-i18next';
import { Global } from 'iconsax-react';
import { useConfig } from '../../../Hooks/useConfig';
import { setCookie } from '../../../utils/cookies';
const LanguageSelectorBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
  borderRadius: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'all .1s linear',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.primary.primary_40
        : theme.palette.primary.primary_99,
  },
}));

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const { baseDomain } = useConfig();
  const selectedLanguage = (value) => {
    i18n.changeLanguage(value);
    setCookie('lng', value, 3600, baseDomain);
  };

  const theme = useTheme();
  return (
    <>
      <Dropdown2 selected={selectedLanguage} rightItem list={LanguageList}>
        <Tooltip title={t('global.select_language')} placement="bottom">
          <LanguageSelectorBox>
            <Global size={theme.spacing(4.5)} />
          </LanguageSelectorBox>
        </Tooltip>
      </Dropdown2>
    </>
  );
};
export default LanguageSelector;
